import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StoresContainer = styled(Box)`
  text-align: initial;
`;
